import styled, { css } from "styled-components";

export const reactEasyCropStyles = (dimensions) => ({
  containerStyle: {
    overflow: "visible",
    ...dimensions
  },
  cropAreaStyle: { ...dimensions }
});

export const Wrapper = styled.div`
  margin-bottom: ${({ shouldntOverlay }) => (shouldntOverlay ? "38px" : "0")};
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;

  ${({ templateId, orientation, isLogo }) => {
    if (templateId === "OneToneImage") {
      if (orientation === "vertical") {
        return css`
          margin: 0 auto;
        `;
      } else {
        return css`
          position: absolute;
          bottom: 0;
        `;
      }
    }

    if (templateId === "WaveImage" && orientation !== "vertical" && !isLogo) {
      return css`
        margin-left: auto;
      `;
    }
  }}
`;

export const ZoomControl = styled.div`
  position: absolute;
  top: -4rem;
  left: 50%;
  min-width: 200px;
  width: 60%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  z-index: 4;
  background: white;
  border: 1px solid rgba(75, 85, 99, 0.5);
  box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px;
`;

export const PostPicturePlaceholder = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 4;
  visibility: ${({ isLogo }) => (isLogo ? "hidden" : "visible")};
`;

export const CropperOverflow = styled.div`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  z-index: 1;
  transform: translate(-50%, -50%);
`;

export const CropperArea = styled.div`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;

  .reactEasyCrop_Cover_Vertical {
    max-width: none;
    max-height: 100%;
  }
`;

export const AspectSwitchWrapper = styled.div`
  width: 170px;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
`;

export const ScaleAlert = styled.div`
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translate(-50%, -100%);
  z-index: 2;
  color: #fe6f1f;
  padding: 8px;
  font-weight: 400;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 #1516331a;
  border: 1px solid #fe6f1f;
  background-color: #fff;
`;
